
// vue-styleguidist bug workaround
const $parent = c => typeof $styleguide !== 'undefined' ? $util.component($util.parent(c.$el, $util.component)) : c.$parent;


/**
 * @mixin Telemetry node mixin.
 * Any component that supports generating telemetry data should use this mixin.
 */
export default {
    props: {
        /**
         * Component identifier emitted in telemetry report.
         */
        cid: String
    },

    data() {
        return {
            tmListen: true,
            tmParent: null,
            tmChild: [],
            tmReporter: null,
            tmID: null,
            tmEvent: []
        };
    },

    mounted() {
        if (this.cid != null) {
            let cmp = this;
            while ((cmp = $parent(cmp))) {
                if (cmp.tmChild !== void 0) {
                    cmp.tmAdd(this);
                    this.tmParent = cmp;
                    return;
                }
            }
        }
    },

    beforeDestroy() {
        if (this.tmParent) {
            this.tmParent.tmRemove(this);
        }
    },

    updated() {
        if (this.tmReporter && this.cid && this.tmListen) {
            (this.$refs._in || this.$el).addEventListener('click', this.tmClick);
            (this.$refs._in || this.$el).addEventListener('keypress', this.tmKeypress);
        }
    },

    methods: {

        /**
         * @public Begin recording telemetry data on this node and all child telemetry nodes.
         */
        tmStart(reporter, id) {
            if (this.tmReporter == null) {
                this.tmReporter = reporter || this;
                this.tmID = id && this.cid ? id + '^' + this.cid : (id || this.cid);
                if (this.cid && this.tmListen) {
                    (this.$refs._in || this.$el).addEventListener('click', this.tmClick);
                    (this.$refs._in || this.$el).addEventListener('keypress', this.tmKeypress);
                }
                for (let i = 0; i < this.tmChild.length; i++) {
                    this.tmChild[i].tmStart(reporter || this, this.tmID);
                }
            }
        },

        /**
         * @public Stop recording telemetry data until further notice.
         */
        tmStop() {
            if (this.tmReporter) {
                this.tmReporter = null;
                this.tmID = null;
                if (this.cid && this.tmListen) {
                    (this.$refs._in || this.$el).removeEventListener('click', this.tmClick);
                    (this.$refs._in || this.$el).removeEventListener('keypress', this.tmKeypress);
                }
                for (let i = 0; i < this.tmChild.length; i++) {
                    this.tmChild[i].tmStop();
                }
            }
        },

        /**
         * @public Clear all previously recorded telemetry data.
         */
        tmClear() {
            this.tmEvent = [];
        },

        /**
         * @public Retrieve all previously recorded telemetry data.
         */
        tmReport() {
            return this.tmEvent;
        },

        tmAdd(child) {
            if (!this.tmChild.includes(child)) {
                this.tmChild.push(child);
            }
        },

        tmRemove(child) {
            this.tmChild = this.tmChild.filter(e => e !== child);
        },

        tmClick(e) {
            this.tmReporter.tmEvent.push({
                a: 'click',
                c: this.tmID
            });
        },

        tmKeypress(e) {
            this.tmReporter.tmEvent.push({
                a: 'type',
                c: this.tmID
            });
        }
    }
}
